import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import { IDiscount, IUpsertDiscountPayload } from 'corporate/types';

export const getDiscounts = async <T extends IDiscount>(
  requestPayload: IRequestPayload,
  signal?: AbortSignal
) => {
  const { data } = await partfinitiClient.get(
    `/corporate/discount-list/discounts?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<T>(data.data, data.recordsFiltered);
};

export const upsertDiscount = async <T extends IUpsertDiscountPayload>(payload: T) => {
  return partfinitiClient.postForm('/corporate/discounts/save', payload);
};

export const removeDiscounts = async (data: { ids: number[] }) => {
  return partfinitiClient.postForm('/corporate/discount/remove', data);
};
